import { Pipe, PipeTransform } from '@angular/core';
import { Menu } from '../models/menu.type';
import { findItemById } from '../utils/side-menu.utils';

@Pipe({ name: 'isGrandChild' })
export class IsGrandChildPipe implements PipeTransform {
    transform(parentId: number | undefined | null, menu: Menu): boolean {
        if (!parentId) return false;

        return !!findItemById(menu.items, parentId)?.parentId;
    }
}
